import script from "./ReportFree.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportFree.vue?vue&type=script&setup=true&lang=js"

import "./ReportFree.vue?vue&type=style&index=0&id=c74a51e8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c74a51e8"]])

export default __exports__